import {mock} from './index';

export default {
  getAppList: () => mock('/admin/app/list'),
  setAppStatus: () => mock('/admin/app/status/set'),
  getAppDetail: () => mock('/admin/app/get'),
  assignAppStructure: () => mock('/admin/app/structure/assign'),
  getAppAuthorizationInfo: () => mock('/admin/app/authorization/info'),
  setAppAuthorization: () => mock('/admin/app/authorization/set'),
  getAppListWithOrder: () => mock('/admin/app/category/order/list'),
  setAppListWithOrder: () => mock('/admin/app/order/modify'),
  getAppDesignEnable: () => mock('/admin/app/design/enable'),
  getAppRunEnable: () => mock('/app/run/enable'),
  setNewNavigation: () => mock('/admin/app/newNavigation/set')
};
